import { ParsedMathJax } from '../../pages/components/ParsedMathJax';
import { ApiResponse, PatchDocumentFromJSON, ProjectApi } from '../../api/core';
import * as React from 'react';
import { NavigateFunction } from 'react-router';
import { IntlShape } from 'react-intl';
import { ToastContextType } from '../providers/ToastProvider';

export const requestDeleteProject = (projectApi: ProjectApi, toast: ToastContextType, intl: IntlShape, navigate: NavigateFunction, projectId: number, projectTitle: string, redirectPath?: string): void => {
  toast.confirm({
    message:
      <ParsedMathJax content={intl.formatMessage({id: 'project.deleteRequest.popup.message(projectTitle)'}, {projectTitle})} />,
    header: intl.formatMessage({id: 'message.deleteRequest.popup.label'}),
    icon: 'pi pi-info-circle',
    defaultFocus: 'reject',
    acceptClassName: 'p-button-danger',
    acceptLabel: intl.formatMessage({id: 'button.confirm'}),
    accept: async (): Promise<void> => {
      try {
        await projectApi.updateProject({
          projectId,
          patchDocument: [
            PatchDocumentFromJSON({
              op: 'replace',
              path: '/adminDataProject/editorialStatus',
              value: 'deleted',
            }),
          ],
        });
        toast.notify({
          summary: intl.formatMessage({id: 'message.deletionRequest.success.title'}),
          detail: intl.formatMessage({id: 'message.deletionRequest.success.message'}),
          severity: 'success',
        });
        void navigate(redirectPath || '/search/projects');
      } catch (e) {
        console.error('Deletion request: ', e);
        toast.alert({
          header: intl.formatMessage({id: 'message.deletionRequest.failed.title'}),
          message: intl.formatMessage({id: 'message.deletionRequest.failed.message'}),
        });
      }

    },
    rejectLabel: intl.formatMessage({id: 'button.abort'}),
  });
};

export const deleteProject = (projectApi: ProjectApi, toast: ToastContextType, intl: IntlShape, navigate: NavigateFunction, projectId: number, projectTitle: string, redirectPath?: string): void => {
  toast.confirm({
    message:
      <div>
        <p>{intl.formatMessage({id: 'project.delete.popup.message'})}</p>
        <p><strong><ParsedMathJax content={projectTitle} /> (ID: {projectId})</strong></p>
      </div>,
    header: intl.formatMessage({id: 'project.delete.popup.label'}),
    icon: 'pi pi-info-circle',
    defaultFocus: 'reject',
    acceptClassName: 'p-button-danger',
    acceptLabel: intl.formatMessage({id: 'button.confirm'}),
    accept: async (): Promise<void> => {
      try {
        const response: ApiResponse<void> = await projectApi.deleteProjectRaw({projectId});
        if (!response.raw.ok) {
          throw new Error(response.raw.statusText);
        }
        toast.notify({
          summary: intl.formatMessage({id: 'message.deletion.success.title'}),
          detail: intl.formatMessage({id: 'message.deletion.success.message'}),
          severity: 'success',
        });
        void navigate(redirectPath || '/search/projects');
      } catch (e) {
        console.error('Delete failed: ', e);
        toast.alert({
          header: intl.formatMessage({id: 'message.deletion.failed.title'}),
          message: intl.formatMessage({id: 'message.deletion.failed.message'}),
        });
      }

    },
    rejectLabel: intl.formatMessage({id: 'button.abort'}),
  });
};
